import { COMMON_TRANSFORM_RESPONSE_FUNCTION, CONFIG_ACTION } from "../../app/constants/api";
import { apiSlice } from "../../app/redux/apiSlice";

export const AppSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    configAction: builder.mutation({
      query: ({ action, payload = {} }) => ({
        url: CONFIG_ACTION.BASE,
        method: "POST",
        body: { action, payload },
      }),
      ...COMMON_TRANSFORM_RESPONSE_FUNCTION,
    }),
  }),
});

export const { useConfigActionMutation } = AppSlice;
